import React from 'react';
import { getSlider } from 'utils';

export default Component => props => (
    <Component {...props} slider={getSlider()} />
);
